import { FetchManager } from "services/util/FetchManager";

export const FetchManagerInstance = new FetchManager();
export { FetchManagerInstance as FetchManager };

const currentMode = () => {
  if (process.env.NODE_ENV === "development") return true;
  else if (process.env.NODE_ENV === "production") return false;
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const HOST = process.env.REACT_APP_SERVER_HOST;
export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST;

export const DEV_MODE = currentMode();
export const ELECTRON_API = window.electronAPI;

console.log(
  `%c███████╗██╗   ██╗███╗   ██╗ ██████╗██████╗  ██████╗ ██╗  ██╗
%c██╔════╝╚██╗ ██╔╝████╗  ██║██╔════╝██╔══██╗██╔═══██╗╚██╗██╔╝
%c███████╗ ╚████╔╝ ██╔██╗ ██║██║     ██████╔╝██║   ██║ ╚███╔╝ 
%c╚════██║  ╚██╔╝  ██║╚██╗██║██║     ██╔══██╗██║   ██║ ██╔██╗ 
%c███████║   ██║   ██║ ╚████║╚██████╗██████╔╝╚██████╔╝██╔╝ ██╗
%c╚══════╝   ╚═╝   ╚═╝  ╚═══╝ ╚═════╝╚═════╝  ╚═════╝ ╚═╝  ╚═╝`,
  "color: #b3dcff;",
  "color: #92cdff;",
  "color: #6dbcff;",
  "color: #4faeff;",
  "color: #2e9fff;",
  "color: #098eff;"
);

// ag-grid에서 라이센스로 인해 발생하는 콘솔 오류를 가리는 로직 (console.error 재정의)
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === "string" &&
    (args[0].includes("Grid Enterprise License") ||
      args[0].includes("Invalid License Key") ||
      args[0].includes("Your license key is not valid") ||
      args[0] ===
        "****************************************************************************************************************************")
  ) {
    return;
  }
  originalConsoleError(...args);
};
